import {
  format,
  setHours,
  setMinutes,
  setSeconds,
  subDays,
  addDays,
} from "date-fns";

export const toISTStart = (date: Date): string =>
  format(
    setSeconds(setMinutes(setHours(subDays(date, 1), 18), 30), 0),
    "yyyy-MM-dd HH:mm:ss"
  );

export const toISTEnd = (date: Date): string =>
  format(
    setSeconds(setMinutes(setHours(date, 18), 29), 0),
    "yyyy-MM-dd HH:mm:ss"
  );

/** Parse an IST-start boundary string ("yyyy-MM-dd HH:mm:ss") back to a local Date,
 *  then add 1 day to recover the original calendar day. */
export const fromISTStart = (dateStr: string | Date): Date => {
  if (dateStr instanceof Date) return addDays(dateStr, 1);
  // Replace the space separator with T so new Date() parses it as local time
  const d = new Date(dateStr.replace(" ", "T"));
  return addDays(d, 1);
};

/** Parse an IST-end boundary string ("yyyy-MM-dd HH:mm:ss") back to a local Date. */
export const fromISTEnd = (dateStr: string | Date): Date => {
  if (dateStr instanceof Date) return dateStr;
  return new Date(dateStr.replace(" ", "T"));
};
